import { FaLinkedinIn,  FaFacebookF, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';
import image from '../img/logo.png';
import '../../components/Footer/Footer.scss';
import { NavLink } from "react-router-dom";


const Footer = () => {
  return (
    <div className="pg-footer">
      <footer className="footer">
       
        <div className="footer-content">
          <motion.div
            className="footer-content-column"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="footer-logo">
              <a className="footer-logo-link" href="#">
                <img
                  src={image}
                  alt="Logo"
                  className="footer-logo-img"
                  style={{ width: '150px' }} // Adjust the logo size here
                />
              </a>
            </div>
            <div className="footer-company-description">
              <p className="company-description">
                Care Health Nurses Pvt. Ltd. Services provides personalized healthcare solutions, including medical assistance, post-operative care, elderly care, and more. We aim to deliver reliable, timely, and compassionate services to all patients.
              </p>
            </div>
          </motion.div>
          
          <motion.div
            className="footer-content-column"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="footer-menu">
              <h2 className="footer-menu-name">Company</h2>
              <ul id="menu-company" className="footer-menu-list">
                <li className="menu-item">
                  <a href="#">Contact</a>
                </li>
                <li className="menu-item">
                  <a href="#">News</a>
                </li>
                <li className="menu-item">
                  <a href="#">Careers</a>
                </li>
              </ul>
            </div>
            <div className="footer-menu">
              <h2 className="footer-menu-name">Legal</h2>
              <ul id="menu-legal" className="footer-menu-list">
                <li className="menu-item">
                  <a href="#">Privacy Notice</a>
                </li>
                <li className="menu-item">
                  <a href="#">Terms of Use</a>
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="footer-content-column"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="footer-menu">
          <h2 className="footer-menu-name">Quick Links</h2>
          <ul id="menu-quick-links" className="footer-menu-list">
            <li className="menu-item">
              <NavLink to="/" className="footer-nav-link">
                Home
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/About" className="footer-nav-link">
                About
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Services" className="footer-nav-link">
                Services
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Contact" className="footer-nav-link">
                Contact
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Services/Attendants" className="footer-nav-link">
                Male / Female Nurses Staff
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Services/Male" className="footer-nav-link">
                Male Attendant
              </NavLink>
            </li>
            {/* <li className="menu-item">
              <NavLink to="/Services/Attendants" className="footer-nav-link">
                Female Attendants / Nursing Attendants
              </NavLink>
            </li> */}
            <li className="menu-item">
              <NavLink to="/Services/ElderlyCare" className="footer-nav-link">
                Elder / Old And Senior Citizens Caretaker Services
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Services/BabyCare" className="footer-nav-link">
                Baby Care / New Born Care
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink to="/Services/HomePatientCare" className="footer-nav-link">
                Home Patient Care
              </NavLink>
            </li>
          
          </ul>
        </div>
      </motion.div>

          <motion.div
            className="footer-content-column"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <div className="footer-call-to-action">
              <h2 className="footer-call-to-action-title">Let's Chat</h2>
              <p className="footer-call-to-action-description">Have a support question?</p>
              <a className="footer-call-to-action-button button" href="#" target="_self">
                Get in Touch
              </a>
            </div>
            <div className="footer-call-to-action">
              <h2 className="footer-call-to-action-title">You Call Us</h2>
              <p className="footer-call-to-action-link-wrapper">
              
                <  a className="footer-call-to-action-link" href="tel:+91-9999790231" target="_self">
                +91-9999790231
                </a>
                <br />
                <a className="footer-call-to-action-link" href="tel:+91-9999407473" target="_self">
                +91-9999407473
                </a>
              </p>
              
              <div className="footer-social-media">
          <h2 className="footer-social-media-title">Follow Us</h2>
          <div className="footer-social-media-icons">
            <a href="https://www.facebook.com/carehealthnursingbureau/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaFacebookF />
            </a>
            {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaTwitter />
            </a> */}
            <a href="https://www.instagram.com/carehealthnurses/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/care-health-nurses/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaLinkedinIn />
            </a>
          </div>
        </div>

            </div>
            
          </motion.div>
          
          

        
        </div>
        <div className="footer-copyright">
          <div className="footer-copyright-wrapper">
            <p className="footer-copyright-text">
              <a className="footer-copyright-link" href="#" target="_self">
                Copyright © 2018 Care Health Nurses Pvt. Ltd. Services All rights reserved
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
